import type { ReactNode } from "react";
import { BUIProvider as Provider } from "@bookingcom/bui-react";
import travellerTheme from "@bookingcom/bui-react/themes/traveller";
import { DEFAULT_LOCALE } from "../constants/locale";

export const BUIProvider = ({ children }: { children: ReactNode }) => (
  <Provider theme={travellerTheme} locale={DEFAULT_LOCALE}>
    {children}
  </Provider>
);
